<div class="amp-dialog">
  <p class="amp-dialog-title"><i class="bi-exclamation-triangle-fill"></i>&nbsp;Erro</p>
  <div class="amp-dialog-subtitle">
    <b>Razão:</b>
    {{ checkMessageDelivered(content.errorMessage) }}
  </div>
    <div class="amp-buttons">
      <button type="button" class="amp-btn-outline-cancel amp-btn-lg" (click)="closeModal()">Fechar</button>
    </div>
</div>